import React from 'react';
import { Input } from '@/components/ui/input';

interface AuthFieldProps {
  label: string;
  name: string;
  type?: string;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  disabled?: boolean;
}

/**
 * AuthField - Reusable form field wrapper for authentication forms
 * Encapsulates Input component with consistent label and error handling
 * Reduces prop duplication across multiple form fields
 */
export function AuthField({
  label,
  name,
  type = 'text',
  placeholder,
  value,
  onChange,
  error,
  disabled = false,
}: AuthFieldProps) {
  return (
    <Input
      label={label}
      name={name}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      error={error}
      disabled={disabled}
    />
  );
}
